import { useSelector } from 'react-redux';
import { selectActiveCapabilities } from '../../../../store/userGroups';
import { Permission, PermissionService } from './PermissionService';
import { RootStore } from '../../../../store/reducer';

export function createPermissionService(config: {
  store: { getState: () => RootStore };
  getIsSuperUser: () => boolean;
}): PermissionService {
  function checkPermission(
    activePermissions: Partial<Record<Permission, boolean>>,
    requiredPermission: Permission
  ): boolean {
    if (config.getIsSuperUser()) {
      return true;
    }
    return !!activePermissions[requiredPermission];
  }

  return {
    useHasPermission: () => {
      const activePermissions = useSelector(selectActiveCapabilities);
      return (permission: Permission) =>
        checkPermission(activePermissions, permission);
    },

    hasPermission: (permission: Permission) => {
      const state = config.store.getState();
      const activePermissions = selectActiveCapabilities(state);
      return checkPermission(activePermissions, permission);
    }
  };
}
